import { FC, ReactNode, useRef, MouseEvent } from 'react'

import { useOnClickOutside } from '../hooks/useOnClickOutside'
import './Menu.scss'

type Props = {
    title?: string
    visible: boolean
    children: ReactNode
    onOutsideClick: () => void
}

const Menu: FC<Props> = ({ title = '', visible, children, onOutsideClick }: Props) => {
    const menuRef = useRef<HTMLDivElement>(null)
    useOnClickOutside(menuRef, onOutsideClick)

    if (!visible) return <></>

    return (
        <div
            ref={menuRef}
            className="menu offset">
            {
                title ? (
                    <>
                        <MenuItem text={title} disabled={true} />
                        <MenuItemSeparator />
                    </>
                ) : <></>
            }
            {children}
        </div>
    )
}

type MenuItemProps = {
    text: string
    onClick?: (e: MouseEvent<HTMLElement>) => void
    disabled?: boolean
}

export const MenuItem: FC<MenuItemProps> = ({ text, onClick = () => { }, disabled = false }: MenuItemProps) => (
    <div
        className={`menu--option ${disabled && 'disabled'}`}
        onClick={disabled ? () => { } : onClick}
    >
        {text}
    </div>
)
export default Menu

export const MenuItemSeparator = () => <div className="menu--separator" />
